import { UIMessagePart } from 'ai';

import { partIsTool } from '../utils';

import { Reasoning, Text, Tool } from './parts';
import StepSummary from './StepSummary';

import {
  PathwayUIDataParts,
  PathwayUITools,
} from '@/routes/smart-search/types';

interface StepProps {
  stepParts: UIMessagePart<PathwayUIDataParts, PathwayUITools>[];
  shouldCollapse: boolean;
}

const Step: React.FC<StepProps> = ({ stepParts, shouldCollapse }) => {
  if (shouldCollapse) {
    const summary = stepParts
      .reverse()
      .find(part => part.type === 'data-step-summary')?.data.summary;
    return summary ? (
      <StepSummary summary={summary} stepParts={stepParts} />
    ) : null;
  }

  return stepParts.map((part, i) => {
    if (part.type === 'reasoning') {
      return <Reasoning key={i} part={part} />;
    }
    if (partIsTool(part)) {
      return <Tool key={i} part={part} />;
    }
    if (part.type === 'text') {
      return <Text key={i} part={part} />;
    }
  });
};

export default Step;
